<script setup>
import {onMounted, ref} from "vue";
import router from "../../router.js";
import {forgottenPassword, login, resetPassword} from '@/services/AuthService';
import {getTenantData} from '@/services/TenantService';
import Footer from '@/components/layouts/Footer.vue';
import {setButtonContentDefault, setButtonContentLoading, setButtonContentSuccess, showSuccessMessage} from '@/helper';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const theme = ref({});
const email = ref('');
const password = ref('');
const password_confirmation = ref('');
const token = ref('');
const errorMessage = ref('');

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  token.value = urlParams.get('reset_token');
  email.value = urlParams.get('email');

  if (!token.value || !email.value) {
    router.push('/login');
  }

  getTenantData()
      .then((response) => {
        theme.value = response.theme;
      });
});

const submit = () => {
  if (password.value !== password_confirmation.value) {
    errorMessage.value = t('resetPassword.password_not_match');
    return;
  }

  if (password.value.length < 8) {
    errorMessage.value = t('resetPassword.password_must_be_8_char');
    return;
  }

  const form = {
    email: email.value,
    password: password.value,
    password_confirmation: password_confirmation.value,
    token: token.value
  };
  setButtonContentLoading('btn-login');
  resetPassword(form).then(response => {
    if (response.message === 'auth.password_changed') {
      setButtonContentSuccess('btn-login');
      showSuccessMessage(t('resetPassword.password_successfully_changed'));
    }
    router.push('/login');
  },(error) => {
    errorMessage.value = error.message;
    if (error.message === 'global.not_found') {
      errorMessage.value = t('resetPassword.user_not_found');
    }
    if (error.message === 'auth.reset_password_token_invalid') {
      errorMessage.value = t('resetPassword.reset_link_not_valid');
    }
    setButtonContentDefault('btn-login');
  });
}

</script>

<template>
  <div class="entrance">
    <header class="entrance__header"></header>
    <div class="min-vh-device row justify-content-center align-items-center">
      <div class="col-12 col-md-8 col-lg-6 col-xl-4">
        <div class="entrance__logo" v-if="theme && theme.logoBase64">
          <img :src="theme.logoBase64" v-if="theme && theme.logoBase64" alt="" />
        </div>
        <div class="entrance__title">
          {{ t('resetPassword.password_change') }}
        </div>
        <div class="entrance__content">
          <div class="card">
            <div class="card-body">
              <form @submit.prevent="submit">
                <div class="form-group">
                  <label class="form-label" for="email">{{ t('resetPassword.email:') }}</label>
                  <input id="email" class="form-control" disabled
                         type="email" placeholder="" autocomplete="off"
                         v-model="email" required/>
                </div>
                <div class="form-group">
                  <label class="form-label" for="password">{{ t('resetPassword.password:') }}</label>
                  <input id="password" class="form-control"
                         type="password" placeholder="" autocomplete="off"
                         v-model="password" required/>
                </div>
                <div class="form-group">
                  <label class="form-label" for="password">{{ t('resetPassword.confirm_password:') }}</label>
                  <input id="password" class="form-control"
                          type="password" placeholder="" autocomplete="off"
                          v-model="password_confirmation" required/>
                </div>
                <div class="form-group">
                  <button id="btn-login" type="submit" class="btn btn-primary w-100">
                    <span>{{ t('resetPassword.change_password') }}</span>
                  </button>
                  <div class="alert alert-danger mt-3" v-if="errorMessage"> {{errorMessage}} </div>
                </div>
                <div class="form-group form-group--footer-text">
                  <router-link to="/login">{{ t('resetPassword.back_to_login') }}</router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
